import { render, staticRenderFns } from "./Fundraisings.vue?vue&type=template&id=3f84a405"
import script from "./Fundraisings.vue?vue&type=script&lang=js"
export * from "./Fundraisings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports